import { AutogenLayoutCommissionsProcessingProcess } from "./autogen/AutogenLayoutCommissionsProcessingProcess";
import { ModelRow } from "@mcleod/core";
import { ClickEvent, TableRowDisplayEvent } from "@mcleod/components";
import { CommissionsProcessingUtil } from "./CommissionsProcessingUtil";
import { FilterPanel } from "@mcleod/dispatch";
import { CommissionsProcessingTaskFilter } from "./CommissionsProcessingTaskFilter";
import { CommissionsProcessStepperProps, ProcessCommissionsStepper } from "./ProcessCommissionsStepper";

export class CommissionsProcessingProcess extends AutogenLayoutCommissionsProcessingProcess {
    public filterPanel: FilterPanel;
    public getPayees: () => ModelRow[] = () => [];

    onLoad(): void | Promise<void> {
        this.filterPanel = new FilterPanel([CommissionsProcessingTaskFilter.ORDER_BILLED, CommissionsProcessingTaskFilter.OVERRIDE_RATE], this.tableCommissionsProcessing, this.panelTaskFilters);
        this.tableCommissionsProcessing.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            tableRow.forEveryChildComponent((component) => {
                CommissionsProcessingUtil.setTooltipContent(component, tableRow.data);
            });
            CommissionsProcessingUtil.setComponentDetails(tableRow);
        });
        this.tableCommissionsProcessing.doOnResolveRowEdit = (row) => {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
            return null;
        }
    }

    getLayoutBaseFilter(row: ModelRow): boolean {
        return row.get("ready_to_pay_flag") == "Y";
    }

    /** This is an event handler for the onClick event of buttonProcess. */
    buttonProcessOnClick(event: ClickEvent) {
        const props: CommissionsProcessStepperProps = {
                    startDate: null,
                    endDate: null,
                    payees: this.getPayees(),
                    processRecords: this.tableCommissionsProcessing.rows.map(tableRow => tableRow.data),
                    refreshData: () => {
                        this.mainDataSource.search(this.mainDataSource.lastSearch);
                    }
                };
        ProcessCommissionsStepper.showAsSlideout(props);

    }
}
